import { packageItems } from './cryptoPackageConstants'
import { CryptoPackageModalItem } from './CryptoPackageModalItem'

import classes from './styles/cryptoPackageModalItems.module.scss'

export const CryptoPackageModalItems = () => {
  return (
    <div className={classes.cryptoPackageModalItems}>
      {packageItems.map(item => (
        <CryptoPackageModalItem key={item.id} item={item} />
      ))}
    </div>
  )
}
